module.exports = __webpack_public_path__ + "static/media/course-catalog.27918ef5.svg";